import {Page} from "../Page";
import {$} from "../Application";
import {moment} from "../Application";
import {bootstrap} from "../Application";

export class QuickAdminPanel extends Page {
    runOnCurrentPage(): boolean {
        return true;
    }

    static initDatePicker() {
        // @ts-ignore
        $('.date').datetimepicker({
            format: 'DD.MM.YYYY',
            locale: 'de',
            icons: {
                up: 'fas fa-chevron-up',
                down: 'fas fa-chevron-down',
                previous: 'fas fa-chevron-left',
                next: 'fas fa-chevron-right'
            }
        });
    }

    static initDateTimePicker() {
        // @ts-ignore
        $('.datetime').datetimepicker({
            format: 'DD.MM.YYYY HH:mm:ss',
            locale: 'de',
            sideBySide: true,
            icons: {
                up: 'fas fa-chevron-up',
                down: 'fas fa-chevron-down',
                previous: 'fas fa-chevron-left',
                next: 'fas fa-chevron-right'
            }
        });
    }

    onReady() {
        $(document).ready(function () {
            window._token = $('meta[name="csrf-token"]').attr('content')

            moment.updateLocale('de', {
                week: {
                    dow: 1,
                    doy: 7
                } // Monday is the first day of the week
            });

            QuickAdminPanel.initDateTimePicker();
            QuickAdminPanel.initDatePicker();

            // @ts-ignore
            $('.timepicker').datetimepicker({
                format: 'HH:mm:ss',
                icons: {
                    up: 'fas fa-chevron-up',
                    down: 'fas fa-chevron-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right'
                }
            });

            $('.select-all').on('click', function () {
                let $select2 = $(this).parent().siblings('.select2')
                $select2.find('option').prop('selected', 'selected')
                $select2.trigger('change')
            });
            $('.deselect-all').on('click', function () {
                let $select2 = $(this).parent().siblings('.select2')
                $select2.find('option').prop('selected', '')
                $select2.trigger('change')
            });

            // @ts-ignore
            $('.select2').select2();

            $('.treeview').each(function () {
                var shouldExpand = false
                $(this).find('li').each(function () {
                    if ($(this).hasClass('active')) {
                        shouldExpand = true
                    }
                })
                if (shouldExpand) {
                    $(this).addClass('active')
                }
            });

            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            });

        });
    }
}
